export default {"src":"https://fishbrain.com/_next/static/media/ohio.3e254717.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};